var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeaderDetail',{attrs:{"title":"新增区域","breadcrumb-nav":_vm.breadcrumbNav}},[_c('div',{attrs:{"slot":"right"},slot:"right"},[_c('a-button',{on:{"click":_vm.goBack}},[_vm._v("返回")])],1),_c('AddEditAreaList',{attrs:{"parkId":"null"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }